import React, { useEffect, useState } from "react";
import polaroid from "../../assets/img/footer/polaroid.png";
import logo from "../../assets/img/footer/logo.png";
import download from "../../assets/img/footer/download.png";
import "./contact.css";

import {
  FaEnvelope,
  FaPhone,
  FaGlobe,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

const RECAPTCHA_SITE_KEY = "6LdJtrsrAAAAAGR1yRzjWOJxwWZdWvxgkMK1UXeo"; // ⚠️ à remplacer
const API_URL = "https://azureaprintsolutions.com/send-email.php"; // ⚠️ adapte le chemin

export default function Contact() {
  // Liens & RS (inchangé)
  const link = [
    {
      ico: <FaEnvelope className="link-list__icon" />,
      text1: "admin@azureaprintsolutions.com",
      link1: "mailto:admin@azureaprintsolutions.com",
    },
    {
      ico: <FaPhone className="link-list__icon" />,
      text1: "04 65 84 85 54",
      text2: "06 99 03 69 49",
      link1: "tel:+33465848554",
      link2: "tel:+33699036949",
    },
    {
      ico: <FaGlobe className="link-list__icon" />,
      text1: "www.azureaprintsolutions.com",
      link1: "https://www.azureaprintsolutions.com",
    },
    {
      ico: <FaMapMarkerAlt className="link-list__icon" />,
      text1: "233 routes de Cannes - 06130 Grasse",
      link1: "https://maps.app.goo.gl/h4VC6pa1zbhEZ8Qq8",
    },
  ];

  const socials = [
    {
      ico: <FaInstagram className="link-list__icon" />,
      text: "Instagram",
      href: "https://www.instagram.com/aps06130/",
    },
    {
      ico: <FaFacebookF className="link-list__icon" />,
      text: "Facebook",
      href: "https://www.facebook.com/people/Azurea-Print-Solutions/61569368392467/",
    },
    {
      ico: <FaLinkedinIn className="link-list__icon" />,
      text: "Linkedin ",
      href: "https://fr.linkedin.com/company/azurea-print-solutions",
    },
  ];

  // ---- State formulaire ----
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [service, setService] = useState(""); // 'commercial' | 'technique' | 'administratif'
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // { ok:bool, text:string }

  // Charge le script reCAPTCHA v3
  useEffect(() => {
    if (!RECAPTCHA_SITE_KEY) return;
    const id = "recaptcha-script";
    if (document.getElementById(id)) return;
    const s = document.createElement("script");
    s.id = id;
    s.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  const getRecaptchaToken = async () => {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha || !RECAPTCHA_SITE_KEY) {
        resolve(""); // si pas configuré, on tente sans (le PHP refusera)
        return;
      }
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(RECAPTCHA_SITE_KEY, { action: "contact" })
          .then(resolve)
          .catch(() => resolve(""));
      });
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    // Validation client rapide
    if (!firstName || !lastName || !email || !service || !message) {
      setStatus({ ok: false, text: "Merci de remplir les champs requis." });
      return;
    }

    setLoading(true);
    try {
      const recaptchaToken = await getRecaptchaToken();

      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName,
          lastName,
          company,
          phone,
          email,
          service, // 'commercial' | 'technique' | 'administratif'
          message,
          recaptchaToken,
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setStatus({
          ok: true,
          // text: "Merci ! Votre message a bien été envoyé.",
        });
        // reset
        setFirstName("");
        setLastName("");
        setCompany("");
        setPhone("");
        setEmail("");
        setService("");
        setMessage("");
      } else {
        setStatus({
          ok: false,
          text: data?.message || "Une erreur est survenue.",
        });
      }
    } catch (err) {
      setStatus({ ok: false, text: "Impossible d’envoyer le message." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="Contact" id="contact">
      <article className="Contact__links">
        <h2>
          Entrons <br /> en <span className="opacity">contact</span>
        </h2>

        <article className="link-list">
          {link.map(({ ico, text1, text2, link1, link2 }, idx) => (
            <li key={idx} className="link-list__item">
              <span className="link-list__icon">{ico}</span>
              <div>
                <a href={link1} className="link-list__text">
                  {text1}
                </a>
                {text2 && (
                  <a href={link2} className="link-list__text">
                    {text2}
                  </a>
                )}
              </div>
            </li>
          ))}
        </article>

        <div className="line" />

        <article>
          <p className="blue">Retrouvez nous sur :</p>
          <div className="social-list">
            {socials.map(({ ico, href, text }, idx) => (
              <a
                key={idx}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="link-list__item"
              >
                <span className="link-list__icon">{ico}</span>
                <p className="link-list__text">{text}</p>
              </a>
            ))}
          </div>
        </article>
      </article>

      <article className="Contact-form__container">
        <h2>Discutons ensemble !</h2>

        <form onSubmit={handleSubmit} className="Contact-form">
          <input
            type="text"
            placeholder="Nom *"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Prénom *"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Société"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
          />
          <input
            type="tel"
            placeholder="Téléphone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <input
            type="email"
            placeholder="E-mail *"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <select
            value={service}
            onChange={(e) => setService(e.target.value)}
            required
          >
            <option value="" disabled>
              Choisir un service *
            </option>
            <option value="commercial">Service commercial</option>
            <option value="technique">Service technique</option>
            <option value="administratif">Service administratif</option>
          </select>

          <textarea
            placeholder="Votre message... *"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Envoi en cours..." : "Envoyer"}
          </button>

          {status && (
            <p className={`Contact-form__status ${status.ok ? "ok" : "err"}`}>
              {status.text}
            </p>
          )}
        </form>

        <p className="Contact-form__privacy">
          *Nos marques partenaires fiables et fidèles qui nous accompagnent
          depuis nos débuts TOSHIBA I KONICA MINOLTA I EASYPITCH I UNYC I EUKLES
          SOLUTIONS I DOCAPOSTE I NUMEXO…
        </p>
      </article>
    </section>
  );
}
